// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var DomainModel$ReactHooksTemplate = require("./settings/domainModel.res.js");

function ForgetPassword(props) {
  var match = React.useState(function (param) {
        return Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined);
      });
  var setEmail = match[1];
  var email = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setError = match$1[1];
  var error = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setSuccessMsg = match$2[1];
  var successMsg = match$2[0];
  var match$3 = React.useState(function (param) {
        return true;
      });
  var setShowForm = match$3[1];
  var showForm = match$3[0];
  var handleEmailChange = function ($$event) {
    var value = $$event.target.value;
    Curry._1(setEmail, (function (param) {
            return value;
          }));
    Curry._1(setError, (function (param) {
            
          }));
  };
  var handleSubmit = function (param) {
    Curry._1(setError, (function (param) {
            
          }));
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              var message = Json_decode.field("message", Json_decode.string, response);
              Curry._1(setSuccessMsg, (function (param) {
                      return message;
                    }));
              Curry._1(setShowForm, (function (param) {
                      return false;
                    }));
            } else {
              var error = Json_decode.field("errors", Json_decode.string, response);
              Curry._1(setError, (function (param) {
                      return error;
                    }));
            }
            return Promise.resolve();
          }), Http$ReactHooksTemplate.fetchPostEncodedJSON("/users/password", Json_encode.object_({
                  hd: [
                    "user",
                    Json_encode.object_({
                          hd: [
                            "email",
                            Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email)
                          ],
                          tl: /* [] */0
                        })
                  ],
                  tl: /* [] */0
                })));
  };
  var handleKeyDown = function ($$event) {
    var key = $$event.key;
    if (key === "Enter" && showForm) {
      $$event.preventDefault();
      return handleSubmit();
    }
    
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            className: "h-full w-full object-cover",
                            src: Image$ReactHooksTemplate.signupOnboarding
                          }),
                      className: "w-1/2 max-h-full"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("img", {
                                            className: "h-40-px w-120-px",
                                            src: Image$ReactHooksTemplate.geckolystLogoWithText
                                          }),
                                      className: "flex items-center"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("button", {
                                              children: "Need help?",
                                              className: "text-sm text-darksilver hover:text-indigo-600 p-2"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      src: Image$ReactHooksTemplate.headphone
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: "Contact Us",
                                                      className: "flex items-center h-full w-20"
                                                    })
                                              ],
                                              className: "rounded-lg text-darkcharcoal border border-gainsboro flex gap-2 p-2 font-medium text-sm"
                                            })
                                      ],
                                      className: "flex gap-2"
                                    })
                              ],
                              className: "flex justify-between w-full px-6 py-4 border-b border-platinum bg-white"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            showForm ? JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("p", {
                                                          children: "Enter registered email address",
                                                          className: "text-darkcharcoal text-1xl font-medium px-3"
                                                        }),
                                                    className: "text-center flex flex-col gap-2 w-1/2"
                                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                            showForm ? JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx("label", {
                                                                  children: "Email",
                                                                  className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                  htmlFor: "email"
                                                                }),
                                                            JsxRuntime.jsx("input", {
                                                                  className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                  id: "email",
                                                                  placeholder: "Enter your email",
                                                                  type: "email",
                                                                  value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, email),
                                                                  onKeyDown: handleKeyDown,
                                                                  onChange: handleEmailChange
                                                                }),
                                                            error !== undefined ? JsxRuntime.jsx("div", {
                                                                    children: error,
                                                                    className: "text-red-500 text-sm mt-1 text-left"
                                                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                          ],
                                                          className: ""
                                                        }),
                                                    className: "text-center flex flex-col gap-8 w-1/2 max-w-390-px"
                                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                            successMsg !== undefined ? JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("div", {
                                                            children: successMsg,
                                                            className: "text-darkcharcoal text-1xl font-medium px-3"
                                                          }),
                                                      JsxRuntime.jsx("button", {
                                                            children: "Send Reset Link",
                                                            className: "py-10-px px-30-px rounded-lg w-full bg-black text-ufogreen cursor-pointer hover:opacity-90",
                                                            onClick: (function (param) {
                                                                Curry._1(setShowForm, (function (param) {
                                                                        return true;
                                                                      }));
                                                                Curry._1(setSuccessMsg, (function (param) {
                                                                        
                                                                      }));
                                                              })
                                                          })
                                                    ],
                                                    className: "text-center flex flex-col gap-4 w-1/2 max-w-390-px"
                                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                            showForm ? JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("div", {
                                                          children: JsxRuntime.jsx("button", {
                                                                children: "Send Reset Link",
                                                                className: "py-10-px px-30-px rounded-lg w-full bg-black text-ufogreen cursor-pointer hover:opacity-90",
                                                                onClick: (function (param) {
                                                                    handleSubmit();
                                                                  })
                                                              }),
                                                          className: "w-full"
                                                        }),
                                                    className: "flex items-center w-1/2 max-w-390-px"
                                                  }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                          ],
                                          className: "flex items-center justify-center flex-col gap-8"
                                        }),
                                    className: "w-full justify-center"
                                  }),
                              className: "flex items-center justify-center w-full h-4/5"
                            })
                      ],
                      className: "w-1/2 max-h-full bg-ghostwhiteblue"
                    })
              ],
              className: "flex h-full"
            });
}

var make = ForgetPassword;

exports.make = make;
/* react Not a pure module */
